import React from 'react';
import styled from 'styled-components';

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default LeftContainer;
